import React from 'react';
import Reveal from '../ui/Reveal';
import SectionHeader from '../ui/SectionHeader';
import './About.css';

const PARAGRAPHS = [
  <>
    I hold a B.Sc. in Computer Engineering from Doğuş University, completed on a 100% scholarship,
    and I'm currently an <strong>AI Engineer Intern at Ottovate</strong>, where I work on Vision-Language
    Models and deep learning architectures — pushing detection systems beyond bounding-box
    classification toward contextual scene understanding, alongside comparative research
    across YOLO model generations.
  </>,
  <>
    Before that, I was AI Engineer &amp; Product Owner at PSH Educational Technologies, where I owned
    the full product lifecycle as the sole PM and developer — from defining the roadmap and running
    sprint planning to shipping user-facing features and fine-tuned NLP models that reduced manual
    content creation time by 90%.
  </>,
  <>
    I don't just build features — I think in loops, funnels, and frameworks. I designed <strong>Gloath</strong>,
    a mobile match-2 game, entirely as a PM case study: engineered a 4-loop retention system,
    a dual-currency economy with conversion moment mapping, and a RICE-prioritised feature roadmap.
    I also completed a <strong>Product Management &amp; Ownership Specialisation</strong> (Miuul, 2026)
    covering Scrum, backlog management, data-driven product development, and product metrics.
  </>,
  <>
    On the technical side, my team and I ranked <strong>1st</strong> at the Miuul Datathon
    with TAXIM — an end-to-end ML pipeline on 19M+ rows predicting Istanbul taxi demand.
    At Curiosity Technology, I translated user engagement data into prioritised backlog items
    through statistically validated A/B tests. I've also contributed to a healthcare AI
    solution at the Microsoft × Ubitech AI for Good Hackathon.
  </>,
];

const About = () => (
  <section id="about" className="section about">
    <div className="container">
      <SectionHeader eyebrow="about" title="Hi, I'm Neva." />
      <div className="about-grid">
        <Reveal className="about-pull">
          <p className="t-display about-quote">
            Vision, language, or agents — the throughline is the same: getting models out of the
            notebook and into systems people actually use.
          </p>
        </Reveal>
        <div className="about-text">
          {PARAGRAPHS.map((p, i) => (
            <Reveal as="p" key={i} delay={i * 0.06} className="about-p">{p}</Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default About;
